
<ng-container *ngComponentOutlet="component; inputs: { context }"/>
